import { CircularProgress } from '@mui/material';
import { styled } from '@mui/system';
import { alpha, useTheme } from '@mui/material/styles';

const StyledLoading = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.04)} 0%, ${alpha(theme.palette.secondary.main, 0.06)} 100%)`,
  '& img': {
    width: 'auto',
    height: '25px',
  },
  '& .circleProgress': {
    position: 'absolute',
    left: -7,
    right: 0,
    top: 'calc(50% - 25px)',
  },
}));

const Loading = () => {
  const theme = useTheme();
  return (
    <StyledLoading>
      <div style={{ position: 'relative' }}>
        <img src="/assets/images/logo-circle.svg" alt="" />
        <CircularProgress
          className="circleProgress"
          thickness={3.6}
          sx={{ color: theme.palette.primary.main }}
        />
      </div>
    </StyledLoading>
  );
};

export default Loading;
